<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components'

import BaseButton from '@/shared/components/button/BaseButton.vue'
import CaretIcon from '@/shared/components/icon/CaretIcon.vue'
import SvgIcon from '../icon/SvgIcon.vue'
import ScaleTransition from '../transitions/ScaleTransition.vue'

interface Props {
  title: string
  icon?: string
  loading?: boolean
  disabled?: boolean
}

defineProps<Props>()
const model = defineModel<boolean>({ required: true })

const onClose = (): void => {
  model.value = false
}
</script>

<template>
  <div class="relative" v-on-click-outside="() => onClose()">
    <BaseButton
      :title="title"
      class="flex items-center border-l border-y border-gray-500 text-sm p-2 not-disabled:hover:bg-gray-100"
      :class="model ? 'shadow-inner bg-gray-100' : 'bg-white'"
      :loading="loading"
      :disabled="disabled"
      @click="model = !model"
    >
      <SvgIcon v-if="icon" :path="icon" class="h-5 w-5" />
      <CaretIcon :active="model" class="w-5 h-5" />
    </BaseButton>
    <ScaleTransition>
      <div
        v-if="model && !loading"
        class="z-10 absolute right-0 origin-top-right border border-gray-500 mt-px px-4 text-nowrap bg-white shadow-md"
      >
        <slot></slot>
      </div>
    </ScaleTransition>
  </div>
</template>
